export default __webpack_public_path__ + "static/media/StainlessSteelTableImg.37a831f6.jpg";